<template>
	<b-modal id="modal-recalcularPromedio" size="xl" cancel-title="Cerrar" :ok-disabled="true">
		<template v-slot:modal-title>
			<label>Recalcular Promedio</label>
		</template>
		
		<b-form-group>
			<label> {{ jsonCurso.idCurso }} {{ jsonCurso.tituloCurso }} </label>
		</b-form-group>
		<div
			style="overflow-y: scroll; height: 400px;"
		>
		<a v-if="!isLoading"></a>
		<PuSkeleton v-else :count="2"></PuSkeleton>

		<table class="table">
			<thead>
				<tr>
				<th scope="col">#</th>
				<th scope="col">ID Alumno</th>
				<th scope="col">Nombre Alumno</th>
				<th scope="col">N° Documento</th>
				<th scope="col">Promedio</th>
				</tr>
			</thead>

			
			<tbody>
				<tr v-for="alumno in listadoAlumnos" :key="alumno.idAlumno">
					<td class="checkboxValue" style="text-align: initial;">
						<b-form-checkbox @change="changeCheck(alumno.idAlumno, alumno.estado)"
							v-model="alumno.estado"
							size="sm"
						>
						</b-form-checkbox>
					</td>
					<td style="text-align: initial;">
							{{alumno.idAlumno}}
					</td>
					<td style="text-align: initial;">
							{{alumno.nombre}}
					</td>
					<td style="text-align: initial;">
							{{alumno.numeroDocumento}}
					</td>
					<td style="text-align: initial;">
							{{alumno.promedioFinal}}
					</td>
				</tr>
			</tbody>
			
		</table>
		
		</div>
		<small>Listado de alumnos disponibles.</small>
        <b-form-checkbox @change="changeValorAlumno($event)" size="sm">{{tituloMarcarDesmarcar}}</b-form-checkbox>
		 
			<div class="contenedorBotonReiniciar pl-3">
				<button type="button" class="btn btn-primary botonReiniciar" :disabled="validated" @click="submitModalMarcados()">Recalcular a los seleccionados</button>
			</div>
		
		<toastComponent ref="toastComponent" />
	</b-modal>
</template>
<script>
import { mapActions, mapState } from "vuex";
import toastComponent from "@/components/toastComponent.vue";
export default {
	components: {
      toastComponent
	},
	data() {
		return {
			infoCurso: {},
			checked2: true,
			listadoAlumnos: {},
			isLoading: false,
			listadoAlumnosApi:[],
			validated: true,
			tituloMarcarDesmarcar:"Marcar Todos",
		};
	},
	computed: {
		...mapState("curso", ["jsonCurso"]),
		...mapState("alumno", ["jsonAlumno"]),
		
	},
	
	methods: {

		changeCheck(idAlumno, status){
			let test = this.listadoAlumnos.find(x => x.idAlumno === idAlumno);
			//console.log(test);
			if(status == true){
				test.estado = false;
			}
			else {
				test.estado = true;
			}
			let filtroAlumnosRecalcular = this.listadoAlumnos.filter((alumno)=>{
				if(alumno.estado == true){
					return alumno;  
				}else{
					return null
				} 
			});
			if (filtroAlumnosRecalcular.length > 0){
			this.validated = false;
			}
			else {
			this.validated =true;
			}
		},
		async submitModalMarcados(){

			this.isLoading = true;
			this.validated = true;

			let filtroAlumnosRecalcular = this.listadoAlumnos.filter((alumno)=>{
				  if(alumno.estado == true){
					  return alumno;  
				  }else{
					  return null
				  } 
			   });

			if(filtroAlumnosRecalcular.length > 0){

				var formData ={
                    "alumnos": filtroAlumnosRecalcular,
                    "idCurso":this.jsonCurso.idCurso,
					"recalculoMasivo": 0,
                    };

				
				try {

				let result = await this.axios.post('api/recalcularPromediosSP', formData);
				this.isLoading = false;

				if(result.data.msg == 'ok'){

					//console.log(result.data.data);
					result.data.data.forEach(e => {
						let test = this.listadoAlumnos.find(x => x.idAlumno === e.idAlumno);
						test.promedioFinal = e.promedioFinal;
					});

					//mostrar mensaje de cuantos se actualizaron y cuantos eran
					this.$refs.toastComponent.makeToast({
					msg: `Se ha reiniciado la nota para ${filtroAlumnosRecalcular.length} alumnos de un total de ${filtroAlumnosRecalcular.length} alumnos seleccionados`,
					title: "Estado Nota",
					variant: "success",
					});
					return result;
				}
				else {
					this.validated = false;
					this.isLoading = false;

					this.$refs.toastComponent.makeToast({
						msg: `Hubo un problema al recalcular el promedio`,
						title: "Estado Nota",
						variant: "danger",
					});
				}
				}
				catch{
					console.log(error.response); // this is the main part. Use the response property from the error object
					this.$refs.toastComponent.makeToast({
						msg: `Hubo un problema al recalcular el promedio`,
						title: "Estado Nota",
						variant: "danger",
					});
				}
				
			}
			else{
				this.validated = false;
				this.isLoading = false;

			   this.$refs.toastComponent.makeToast({
					msg: `No hay alumnos seleccionados`,
					title: "Estado Nota",
					variant: "danger",
			   });
		   }
			
		},
		
		changeValorAlumno(event){

			if(this.listadoAlumnosApi != null){
				this.listadoAlumnos = this.listadoAlumnosApi.map(elem => {
						elem.idAlumno;
						elem.nombre;
						elem.estado = event;
						return elem;
				});
					let filtroAlumnosRecalcular = this.listadoAlumnos.filter((alumno)=>{
					if(alumno.estado == true){
						return alumno;  
					}else{
						return null
					} 
				});
				if (filtroAlumnosRecalcular.length > 0){
				this.validated = false;
				}
				else {
				this.validated =true;
				}
				if(event){
					this.tituloMarcarDesmarcar = "Desmarcar Todos";

				}else{
					this.tituloMarcarDesmarcar = "Marcar Todos";

				}
			}
		},
		async getInfo(data) {

			//llamar la api para traer los alumnos
			let listadoAlumnosApi = await this.axios.get("api/getAlumnosCursoById/" + this.jsonCurso.idCurso);
			this.listadoAlumnosApi = listadoAlumnosApi.data.alumnoLista;

			this.infoCurso = data;
			if(this.listadoAlumnosApi != null){
				this.listadoAlumnos = this.listadoAlumnosApi.map(elem => {
					elem.idAlumno;
					elem.nombre;
					elem.numeroDocumento;
					elem.promedioFinal;
					elem.estado = false;
					return elem;
				});
			}
		}
	},
	
};
</script>
<style>
 .botonReiniciar{
	 margin-top: 15px;
	 width: 150px;
 }
 .contenedorBotonReiniciar{
	 text-align: center;
 }
 #modal-reinicioControl___BV_modal_footer_ > button.btn.btn-primary.disabled{
	 display: none;
 }
</style>
